class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    
    if(document.querySelectorAll('.header_new_design').length && screen.width > 1024){
      this.predictiveSearchResults = this.querySelector('#header-predictive-search');
    }else{
      this.predictiveSearchResults = this.querySelector('#predictive-search');
    }

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=10&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
      }
    
        if(getCookie('pr_search_recently_viewed') != '') {
          var handles = getCookie('pr_search_recently_viewed').split('||');
          handles.reverse();      
          search_recently_viewed(handles);
        }
        
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);



function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function search_recently_viewed(handles) {
  if(handles.length) {
    var handle = handles.shift();
    var language_change = $('html').attr("lang");
    var new_lag = '';
    if(language_change != 'en'){
    	new_lag = '/'+language_change;
    }

    fetch(new_lag+'/products/'+handle+'/?view=search-recently-view', {
      method: 'get',
    })
      .then(function(response) {
        return response.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var container = doc.querySelector('.product-container');
        if(document.querySelector('.js_add_recent_product') != null){
          document.querySelector('.js_add_recent_product').prepend(container);
        }
        search_recently_viewed(handles)
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}